import fetchAPI from '../../../utils/fetchAPI';

type TParams = {
  requestType: string;
  firstName: string;
  lastName: string;
  contactEmail: string;
  contactPhone?: string;
  languagePreference: string;
  dataSubjectRelation: string;
  dataSubjectEmail: string;
  userId?: string;
  description: string;
  recaptchaToken: string;
  xsrfToken: string;
};

type TPrivacyRequest = {
  accessToken: string;
  userId: number;
};

export default function submitPrivacyRequest({
  requestType,
  firstName,
  lastName,
  contactEmail,
  contactPhone,
  languagePreference,
  dataSubjectRelation,
  dataSubjectEmail,
  description,
  recaptchaToken,
  xsrfToken,
}: TParams): Promise<TPrivacyRequest> {
  return fetchAPI({
    method: 'POST',
    url: '/identity/v2/api/privacy-request',
    xsrfToken,
    payload: {
      requestType,
      firstName,
      lastName,
      contactEmail,
      contactPhone,
      languagePreference,
      dataSubjectRelation,
      dataSubjectEmail,
      description,
      recaptchaToken,
    },
  });
}
